import { render, staticRenderFns } from "./AutoIdentify.vue?vue&type=template&id=fecdbc5a&scoped=true"
import script from "./AutoIdentify.vue?vue&type=script&lang=js"
export * from "./AutoIdentify.vue?vue&type=script&lang=js"
import style0 from "./AutoIdentify.vue?vue&type=style&index=0&id=fecdbc5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fecdbc5a",
  null
  
)

export default component.exports